import {SymbolRestDto} from "@/api/pharma-cms-content-block/models";
import {MultilingualRestDtoModel} from "@/models/MultilingualRestDtoModel";
import {SymbolTargetEnum} from "@/api/enums/symbol-target-enum";
import {SymbolHorizontalPositionEnum} from "@/api/enums/symbol-horizontal-position-enum";
import {SymbolVerticalPositionEnum} from "@/api/enums/symbol-vertical-position-enum";
import {MaterialSymbolRestDtoModel} from "@/models/api/pharma-cms-content-block/MaterialSymbolRestDtoModel";

export class SymbolRestDtoModel implements SymbolRestDto {
    material_symbol: MaterialSymbolRestDtoModel;
    symbol_url?: MultilingualRestDtoModel | null;
    symbol_target?: SymbolTargetEnum | null;
    symbol_page_id?: MultilingualRestDtoModel | null;
    horizontal_position_code: SymbolHorizontalPositionEnum;
    vertical_position_code: SymbolVerticalPositionEnum;

    constructor(material_symbol: MaterialSymbolRestDtoModel, horizontal_position_code: SymbolHorizontalPositionEnum, vertical_position_code: SymbolVerticalPositionEnum) {
        this.material_symbol = material_symbol;
        this.horizontal_position_code = horizontal_position_code;
        this.vertical_position_code = vertical_position_code;
    }

    public static createWithDefaults(): SymbolRestDtoModel {
        const model = new this(
            MaterialSymbolRestDtoModel.createWithDefaults(),
            SymbolHorizontalPositionEnum.LEFT,
            SymbolVerticalPositionEnum.CENTER
        );

        return model;
    }

    public static cloneFrom(source: SymbolRestDto): SymbolRestDtoModel {
        const clone: SymbolRestDtoModel = new this(
            MaterialSymbolRestDtoModel.cloneFrom(source.material_symbol),
            source.horizontal_position_code,
            source.vertical_position_code
        );

        clone.symbol_target = source.symbol_target;
        clone.symbol_url = source.symbol_url ? MultilingualRestDtoModel.cloneFrom(source.symbol_url) : null;
        clone.symbol_page_id = source.symbol_page_id ? MultilingualRestDtoModel.cloneFrom(source.symbol_page_id) : null;

        return clone;
    }
}
